<aeg-datatable :value="announcementList" :loading="isLoading" @row-click="onRowClick" row-hover :row-class="() => 'aeg-datatable-clickable-row'">
    <template #empty>
        U heeft nog geen berichten.
    </template>
    <Column header="Titel" field="title" />
    <Column header="Inhoud" field="message" />
    <Column header="Periode" :field="(announcement) => formatDate(announcement)" />
</aeg-datatable>
